/**
 * Form script
 */
class ComplaintForm {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        let id = null;
        let isCheckStatus = false;

        if (window.location.search.includes('isOpenPopUp')) {
            $('.popup-block-form').removeClass('is-hidden');
            $('body').addClass('no-scroll');

            const urlParams = new URLSearchParams(window.location.search);
            const step = urlParams.get('step');
            id = urlParams.get('applicationId');

            if (step == 2) {
                $('#formStep1').addClass('hide');
                $('#formStep2').removeClass('hide');
            }
            if (step == 5) {
                $('#formStep1').addClass('hide');
                checkStatus();
            }
        }

        $(document).on('click', '#btnReUpload', function () {
            $('#formStep5').addClass('hide');
            $('#formStep2').removeClass('hide');
        });

        $(document).on('click', '#complaintFormButton', function (e) {
            this.complaintForm = $('.complaintForm');
            let formHelper = new FormHelper(this.complaintForm);
            e.preventDefault();

            result = formHelper.formValidate();

            if(result) {
                e.preventDefault();
                const formData = new FormData();
                const url = $(e.target).attr('data-url');
                const token = this.complaintForm.attr('data-token');
                formData.append('comment', $('#complaint_comment').val());
                formData.append('_token', token);
                const files = $('#MultipleFileInput')[0].files;
                $('.btn-submit').addClass('is-loading');

                for (let i = 0; i < files.length; i++) {
                    formData.append(`file[${i}]`, files[i]);
                }

                formData.append('is_terms', $('#complaint_term').is(':checked') ? 1 : 0)

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (res) {
                        $('.btn-submit').removeClass('is-loading');

                        if (res.success === 1) {
                            $('#popupBlockContent').html(res.html);
                        } else {
                            $('#popupBlockContent').html('<p>Nie udało się zapisać danych.</p>');
                        }
                    },
                    error: function (error) {
                        $('.btn-submit').removeClass('is-loading');
                    }
                });
            }
        });


        function checkStatus() {
            $.ajax({
                type: 'GET',
                url: '/application/' + id +'/check-status',
                success: function (res) {
                    if (res.success === 1) {
                        $('#loadingStep').addClass('hide');
                        const status = res.data.status;
                        if (status === 'SUCCESS') {
                            $('#formStep4').html(res.data.html);
                            $('#formStep4').removeClass('hide');
                        } else {
                            $('#formStep5').html(res.data.html);
                            $('#formStep5').removeClass('hide');
                        }
                    } else {
                        $('#popupBlockContent').html('<p>Nie udało się zapisać danych.</p>');
                    }
                },
                error: function (error) {
                    console.log(error);
                }
            })
        }
    }
}
